var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icon-css-ie",
    width: 640,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009A49",
    d: "M0 0h213.3v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7900",
    d: "M426.7 0H640v480H426.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrl);
export default __webpack_public_path__ + "static/media/irl.933683695409183c62c8b8a27439a0f7.svg";
export { ForwardRef as ReactComponent };